export default "__VITE_ASSET__7f5762a3__"